import { createReducer } from '@reduxjs/toolkit';
import { ExtensionShape, ALL_EXTENSIONS_ID } from './model';
import * as extensionActions from './actions';
import * as appActions from '../app/actions';
import * as lastStateActions from '../lastState/actions';

const initial: ExtensionShape = {
  extensions: [],
  selectedIds: [ALL_EXTENSIONS_ID],
  expandedKeys: [],
  loading: false,
};

export const extensionReducer = createReducer<ExtensionShape>(initial, (builder) =>
  builder
    .addCase(extensionActions.extensionsChanged, (s, a) => {
      s.extensions = a.payload.extensions;
    })
    .addCase(extensionActions.extensionsSelected, (s, a) => {
      s.selectedIds = a.payload.ids;
    })
    .addCase(appActions.resetFilters, (s) => {
      s.selectedIds = [ALL_EXTENSIONS_ID];
    })
    .addCase(extensionActions.setExpandedKeys, (s, a) => {
      s.expandedKeys = a.payload.keys;
    })
    .addCase(extensionActions.setLoading, (s, a) => {
      s.loading = a.payload.loading;
    })
    .addCase(lastStateActions.applied, (s, a) => {
      if (a.payload) {
        s.selectedIds = a.payload.state.data.extension.selectedIds;
        s.expandedKeys = a.payload.state.data.extension.expandedKeys;
      } else {
        s.selectedIds = initial.selectedIds;
        s.expandedKeys = initial.expandedKeys;
      }
    }),
);
